import { render } from "./PrintableLicenseSettings.vue?vue&type=template&id=3fac399c"
import script from "./PrintableLicenseSettings.vue?vue&type=script&lang=js"
export * from "./PrintableLicenseSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__